import { format } from 'date-fns'
import { useWebhookLogs } from '@/api/hooks/use-webhooks'
import { Modal } from '@/components/ui/modal'
import { StatusBadge } from '@/components/ui/status-badge'

interface WebhookLogsPanelProps {
  webhookId: string
  onClose: () => void
}

export function WebhookLogsPanel({ webhookId, onClose }: WebhookLogsPanelProps): React.JSX.Element {
  const { data, isLoading } = useWebhookLogs(webhookId)
  const logs = data?.data ?? []

  return (
    <Modal open onClose={onClose} title="Delivery Logs" size="lg">
      {isLoading ? (
        <div className="py-8 text-center text-text-tertiary">Loading logs...</div>
      ) : logs.length === 0 ? (
        <div className="py-8 text-center text-text-tertiary">No delivery logs yet.</div>
      ) : (
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-surface-3">
                <th className="px-3 py-2 text-left text-xs font-medium uppercase text-text-tertiary">
                  Timestamp
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase text-text-tertiary">
                  Event
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase text-text-tertiary">
                  Status
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase text-text-tertiary">
                  HTTP
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase text-text-tertiary">
                  Time
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-surface-2">
              {logs.map((log) => {
                const status = log.status_code < 400 ? 'success' : 'failed'
                return (
                  <tr key={log.id}>
                    <td className="px-3 py-2 text-text-secondary">
                      {format(new Date(log.created_at), 'MMM d, HH:mm')}
                    </td>
                    <td className="px-3 py-2">
                      <StatusBadge status="sent">{log.event_id}</StatusBadge>
                    </td>
                    <td className="px-3 py-2">
                      <StatusBadge status={status === 'success' ? 'delivered' : 'bounced'}>
                        {status}
                      </StatusBadge>
                    </td>
                    <td className="px-3 py-2 font-mono text-xs text-text-secondary">
                      {log.status_code}
                    </td>
                    <td className="px-3 py-2 text-text-secondary">{log.duration_ms}ms</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  )
}
